import AccAccountingSeatConcept from '@/models/Accounting/AccAccountingSeatConcept'
import AccAccountingSeatStatus from '@/models/Accounting/AccAccountingSeatStatus'
import AccAccountingSeatType from '@/models/Accounting/AccAccountingSeatType'
import UserModel from '@/models/General/GUser'
export default [
    {
        name: 'g_generator_user_id',
        props: {
            hideDetails: true,
            label: 'Responsable',
            model: UserModel,
            itemText: 'hr_employee.name_case',
            itemValue: 'id',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'acc_accounting_seat_type_id',
        props: {
            hideDetails: true,
            label: 'Tipo',
            model: AccAccountingSeatType,
            itemText: 'type',
            itemValue: 'id',
            paramSearch: 'type',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'acc_accounting_seat_concept_id',
        props: {
            hideDetails: true,
            label: 'Concepto',
            model: AccAccountingSeatConcept,
            itemText: 'concept',
            itemValue: 'id',
            paramSearch: 'concept',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'acc_accounting_seat_status_id',
        props: {
            hideDetails: true,
            label: 'Estado',
            model: AccAccountingSeatStatus,
            itemText: 'status',
            itemValue: 'id',
            paramSearch: 'status',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    // {
    //     field: 'acc_accounting_seat_type_id',
    //     value: [],
    //     label: 'Tipo',
    //     type: '',
    // },
]
